import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { TextPrimitive } from '#pplx/frontend/aether/primitives/TextPrimitive/index.js';
import { upsellClickedEvent } from '#pplx/frontend/apps/ask/events/unified-upsell/analytics.js';
import { redirectWindow } from '#pplx/frontend/platform-components/redirectWindow.js';
import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const LearnMoreButton = React.memo(function LearnMoreButton({ variant, size = 'default', url, openInNewTab, upsellInformation, }) {
    useIntl();
    const handleClick = useCallback(() => {
        if (url) {
            if (openInNewTab) {
                window.open(url, '_blank');
            }
            else {
                redirectWindow(url, 'Learn more from upsell');
            }
        }
    }, [url, openInNewTab]);
    return (_jsx(Button, { variant: variant, size: size, onClick: handleClick, track: upsellInformation
            ? upsellClickedEvent({
                name: 'upsell clicked',
                data: {
                    upsellLocation: upsellInformation.app_location ?? 'UPSELL_APP_LOCATION_UNSPECIFIED',
                    upsellUUID: upsellInformation.upsell_uuid,
                    upsellName: upsellInformation.name,
                    upsellType: upsellInformation.upsell_type,
                    cta: 'PERMALINK',
                },
            })
            : false, children: _jsx(TextPrimitive, { variant: "small", children: _jsx(FormattedMessage, { defaultMessage: "Learn more", id: "77ed8d8ef9", description: "Action button label in the Learn More Button upsell section" }) }) }));
});
//# sourceMappingURL=LearnMoreButton.js.map